import HomeSolidSVG from "@design-system/ui-icons/vanilla/HomeSolid"
import { createIcon } from "../createIcon"

export const HomeSolidIcon = createIcon(HomeSolidSVG)
